import configuracaoSistema from './configuracao-sistema'
import envioSms from './envio-sms'
import papel from './papel'
import permissaoAcesso from './permissao-acesso'

export default baseUrl => {
    baseUrl = `${baseUrl}/administracao`

    return {
        configuracaoSistema: configuracaoSistema(baseUrl),
        envioSms: envioSms(baseUrl),
        papel: papel(baseUrl),
        permissaoAcesso: permissaoAcesso(baseUrl),
    }
}